import { ParsedUrlQuery } from 'querystring';

const getQueryParams = (query: ParsedUrlQuery) => {
  const local = query.local !== undefined;

  const pageNumber =
    Number(query.segment?.toString().split('-page')[1]) ||
    Number(query.local?.toString().split('-page')[1]) ||
    1;

  const seoSegmentId = local
    ? `/${query.segment?.toString().split('-page')?.[0]}/${
        query.local?.toString().split('-page')?.[0]
      }`
    : `/${query.segment?.toString().split('-page')?.[0]}`;

  const location = query.local?.toString().split('-page')?.[0] || '';

  const queryParams = {
    seoSegmentId,
    local,
    pageNumber,
    location,
    testIDToFireTestExposureEvent:
      typeof query.testIDToFireTestExposureEvent === 'string'
        ? query.testIDToFireTestExposureEvent
        : (query.testIDToFireTestExposureEvent?.[query.testIDToFireTestExposureEvent.length] ?? ''),
  };

  return queryParams;
};

export default getQueryParams;
